import FilterDrawer from './FilterDrawer'
import withState from './withState'

export default withState(FilterDrawer)
